export function formatBytes(value: number | null) {
  if (value === null) return "—";
  if (value < 1024 ** 2) return `${Math.round(value / 1024)} KiB`;
  const units = ["MiB", "GiB", "TiB"];
  // Enter the ladder at MiB: values below 1024^2 were handled above.
  let amount = value / 1024 ** 2;
  let unit = 0;
  while (amount >= 1024 && unit < units.length - 1) {
    amount /= 1024;
    unit += 1;
  }
  return `${amount.toFixed(amount >= 10 ? 0 : 1)} ${units[unit]}`;
}
